module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showSideMenu) ? _c('aside', {
    staticClass: "sidebar animated slideInLeft",
    attrs: {
      "id": "side-menu"
    }
  }, [_c('div', {
    staticClass: "nan",
    attrs: {
      "id": "leftside-navigation"
    }
  }, [_c('ul', {
    staticClass: "nano-content"
  }, [_c('li', {
    staticClass: "sub-menu active"
  }, [_c('a', {
    staticClass: "pointer",
    on: {
      "click": _vm.handleHome
    }
  }, [_c('icon', {
    staticClass: "fa-position",
    attrs: {
      "name": "home"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Home")])], 1)]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.statusLogin),
      expression: "statusLogin"
    }],
    on: {
      "click": _vm.handleMyAccount
    }
  }, [_c('a', {
    staticClass: "pointer"
  }, [_c('icon', {
    staticClass: "fa-position",
    attrs: {
      "name": "user-circle-o"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Account")])], 1)]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.statusLogin),
      expression: "statusLogin"
    }]
  }, [_c('a', {
    staticClass: "pointer",
    on: {
      "click": _vm.handleSignout
    }
  }, [_c('icon', {
    staticClass: "fa-position",
    attrs: {
      "name": "sign-out"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Logout")])], 1)]), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.statusLogin),
      expression: "!statusLogin"
    }]
  }, [_c('a', {
    staticClass: "pointer",
    on: {
      "click": _vm.handleSignin
    }
  }, [_c('icon', {
    staticClass: "fa-position",
    attrs: {
      "name": "sign-in"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Login")])], 1)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "resize",
      rawName: "v-resize",
      value: (_vm.onResize),
      expression: "onResize"
    }],
    attrs: {
      "id": "landing-body"
    },
    on: {
      "touchmove": _vm.preventMobileScroll
    }
  }, [_c('header', {
    staticStyle: {
      "background-color": "white"
    },
    attrs: {
      "id": "cd-header align-right"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": "images/SIR (Small).png",
      "alt": "Homepage"
    },
    on: {
      "click": _vm.handleHome
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "pointer",
    attrs: {
      "id": "cd-menu-trigger"
    },
    on: {
      "click": function($event) {
        _vm.showSideMenu = !_vm.showSideMenu, _vm.hideScroll = !_vm.hideScroll, _vm.handleScroll()
      }
    }
  }, [_c('span', {
    staticClass: "cd-menu-text",
    staticStyle: {
      "color": "black"
    }
  }, [_vm._v("Menu")]), _vm._v(" "), _c('span', {
    staticClass: "cd-menu-icon",
    staticStyle: {
      "background-color": "black"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0",
      "display": "inline-block",
      "height": "70px",
      "float": "right",
      "padding": "0"
    }
  }, [_c('form', {
    attrs: {
      "action": "",
      "autocomplete": "on"
    }
  }, [_c('input', {
    staticStyle: {
      "background-color": "white",
      "text-fill-color": "black"
    },
    attrs: {
      "id": "search",
      "name": "search",
      "type": "text",
      "color": "black",
      "placeholder": "Search..."
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "id": "search_submit",
      "value": "SearchStuff",
      "type": "submit"
    }
  }), _vm._v(" "), _c('icon', {
    staticClass: "search-position",
    staticStyle: {
      "position": "absolute",
      "top": "20px",
      "right": "25px",
      "padding": "5px 5px 5xp 5px",
      "color": "black"
    },
    attrs: {
      "name": "search",
      "scale": "1.4"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    class: {
      paneloverlay: _vm.showSideMenu
    },
    on: {
      "click": function($event) {
        _vm.showSideMenu = !_vm.showSideMenu, _vm.hideScroll = !_vm.hideScroll, _vm.handleScroll()
      }
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f801ad14"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/sidemenu/SideMenu.vue
// module id = 1704
// module chunks = 1